<template>
    <div>
        <div class="model" >
            <div class="flex">
                <div class="flex1 skyBlue center">排名</div>
                <div class="flex4 waterBlue center">姓名</div>
                <div class="flex4 skyBlue center">佣金</div>		
            </div>
            <div class="container" v-for="(item, index) in topProfit" :key="index">
                <div class="left">
                    <div class="No">{{ index + 4 }}</div>
                    <div class="margin">
                    <img :src="
                        users.find(s => s.id === item.convergeKey) ? 
                        users.find(s => s.id === item.convergeKey).headUrl : 
                        '../../../static/img/default.png'
                    " alt="">
                    </div>
                    <div class="overflow">
                        {{
                            users.find(s => s.id === item.convergeKey) ? 
                            users.find(s => s.id === item.convergeKey).nick : 
                            '无'
                        }}
                    </div>
                </div>
                <div class="right">
                    {{
                        (item.sum / 100).toFixed(2) || 0
                    }}
                </div>
            </div>
        </div>
        <!-- 无数据 -->
        <div v-if="topProfit.length === 0" class="empty">
            <img src="../../../static/img/empty.svg" alt="">
            <p class='nodata'>暂无更多信息</p>
        </div>
    </div>
</template>

<script>
export default {
  props: ['users', 'topProfit'],
  name: 'Table',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex div {
    padding: .08rem;
}
.container {
    display: flex;
    font-size: .16rem;
    padding-top: .05rem;
}
.left {
    line-height: .3rem;
    width: 100%;
    display: flex;
    margin-left: .15rem;
    justify-content: flex-start;
}
.left div {
    margin-right: .1rem;
}
.left img {
    width: .3rem;
    height: .3rem;
    border-radius: 50%;
}
.right {
    line-height: .3rem;
    text-align: right;
    margin-right: .5rem;
    width: 100%
}
.No {
    color: #FFC107;
    width: .4rem;
    /*margin-right: .4rem !important;*/
}
.model {
    height: unset !important;
}
.empty {
    text-align: center;
    margin-top: 1.06rem;
}
.nodata {
    color: #7F7F7F;
    margin-top: .22rem;
    font-size: 14pt;
    text-align: center;
}
.overflow {
    max-width: 1.2rem;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.rank {
    width: .2rem;
}
.margin {
    /* margin-left: .2rem; */
}
</style>



// WEBPACK FOOTER //
// src/components/userRankElement/Table.vue